// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__36vJ5","modalFooterButton":"ModalNotes_modalFooterButton__KVJM5"};